<template>
  <section
    v-if="
      userService.hasAnyProfile(loggedUser, [
        PROFIL_UTILISATEUR.ACCOMPAGNATEUR_NATIONAL,
        PROFIL_UTILISATEUR.OBSERVATEUR_NATIONAL,
        PROFIL_UTILISATEUR.SUPER_ADMINISTRATEUR,
        PROFIL_UTILISATEUR.ANIMATEUR_REGIONAL,
        PROFIL_UTILISATEUR.ACCOMPAGNATEUR_REGIONAL,
      ])
    "
  >
    <div class="FirstConnectionView-cards">
      <div v-for="user in demandesEnCours" :key="user.id">
        <GraeMemberDemandeCard
          v-if="canAccept(user)"
          :user-demande="user"
          :reject="deny"
          :accept="accept"
        />
      </div>
    </div>
    <TableFilterView
      :columns="columns"
      :initial-filters="activeFilters"
      page="userList"
      @update-active-filters="updateActiveFilters"
      @update-visible-columns="updateVisibleColumns"
      @export-csv="exportCSV"
      @export-xls="exportXLS"
    />
    <b-table
      :ref="tableRef"
      :striped="config.isStriped"
      :hoverable="config.isHoverable"
      :debounce-search="config.searchDebounce"
      :aria-next-label="config.nextLabel()"
      :aria-previous-label="config.previousLabel()"
      :aria-page-label="config.pageLabel()"
      :aria-current-label="config.currentPageLabel()"
      :per-page="config.perPage"
      :sticky-header="config.stickyHeader"
      :current-page="currentPagedSortedParameter.pageNumber"
      :pagination-position="config.paginationPosition"
      paginated
      backend-pagination
      :sort-icon="config.sortIcon"
      :sort-icon-size="config.sortIconSize"
      backend-sorting
      sort-multiple
      :sort-multiple-data="buefySortingPriority"
      :total="total"
      :data="userslist"
      :loading="isLoading"
      class="userslist"
      :class="{ filtered: activeFilters.length }"
      detail-key="courriel"
      :row-class="
        (row) =>
          (row.statutActivation === 'INSCRIPTION_A_VALIDER' ||
            row.statutActivation === 'EMAIL_A_VALIDER') &&
          canDeleteUser
            ? 'is-waiting'
            : ''
      "
      @sort="onSort"
      @sorting-priority-removed="sortingPriorityRemoved"
      @page-change="onPageChange"
    >
      <b-table-column
        v-for="column in columns"
        :key="column.field"
        v-bind="column"
        :visible="column.visible"
      >
        <template #default="props">
          <div v-if="column.field === 'profil'">
            <b-select
              v-if="canPromote(props.row) || canDemote(props.row)"
              :ref="`select-${props.row.id}`"
              :placeholder="$t('usersList.select-profile')"
              :model-value="props.row.profil"
              @update:model-value="(profil) => changeUserProfile(props.row, profil)"
            >
              <option value="ACCOMPAGNATEUR_REGIONAL">
                {{ $t("ACCOMPAGNATEUR_REGIONAL") }}
              </option>
              <option value="ANIMATEUR_REGIONAL">
                {{ $t("ANIMATEUR_REGIONAL") }}
              </option>
            </b-select>

            <span v-else> {{ $t(props.row.profil) }} </span>
          </div>
          <div v-if="column.field === 'projets'">
            <b-button
              v-if="isVisibleProjects(props.row)"
              type="is-primary"
              :disabled="!isVisibleProjects(props.row)"
              @click="GoToProject(props.row)"
              >{{ $t("usersList.projets") }}
            </b-button>
          </div>
          <div v-if="column.field == statusColumnField">
            <div v-if="canAccept(props.row)">
              <b-select
                v-if="userBeingValidated != props.row['id'] && userBeingRefused != props.row['id']"
                :key="`select-${props.row['id']}-${selectResetCounter[props.row['id']]}`"
                :placeholder="$t('usersList.waiting')"
                @update:model-value="(value) => changeStatut(value, props.row)"
              >
                <option :value="statut.valide">
                  {{ statut.valide }}
                </option>
                <option :value="statut.refuse">
                  {{ statut.refuse }}
                </option>
              </b-select>
              <span v-else-if="userBeingValidated == props.row['id']">
                {{ statut.validated }}
              </span>
              <span v-else>
                {{ statut.refused }}
              </span>
            </div>
            <div v-else>
              {{ $t(props.row["statutActivation"]) }}
            </div>
          </div>

          <div v-if="column.field === 'action' && canDeleteUser">
            <b-button
              type="is-danger is-outlined"
              icon-left="trash"
              :title="$t('usersList.supprimer')"
              @click="deleteUser($event, props.row)"
            >
            </b-button>
            <b-button
              v-if="canValidateEmail(props.row)"
              style="margin-left: 10px"
              type="is-primary is-outlined"
              icon-left="check"
              :title="$t('usersList.validate-email')"
              @click="validateEmail($event, props.row)"
            >
            </b-button>
          </div>

          <div v-if="column.field === 'region'">
            <span v-if="props.row['grae'] && props.row['grae']['region']">
              {{ props.row["grae"]["region"] }}
              <span
                v-if="props.row['instructedGraes'] && props.row['instructedGraes'].length !== 0"
              >
                <span v-for="instructedGrae in props.row['instructedGraes']" :key="instructedGrae">
                  {{ getInstructedGraeRegion(instructedGrae) }}
                </span>
              </span>
              <b-button
                v-if="
                  userService.hasAnyProfile(loggedUser, [
                    PROFIL_UTILISATEUR.SUPER_ADMINISTRATEUR,
                    PROFIL_UTILISATEUR.ACCOMPAGNATEUR_NATIONAL,
                  ]) &&
                  props.row.profil &&
                  userService.hasAnyProfile(props.row, [
                    PROFIL_UTILISATEUR.ACCOMPAGNATEUR_REGIONAL,
                    PROFIL_UTILISATEUR.ANIMATEUR_REGIONAL,
                  ])
                "
                type="is-dark is-outlined"
                icon-left="edit"
                @click="openGRAEDialog($event, props.row)"
              />
            </span>
            <span v-else> </span>
          </div>

          <div
            v-if="!column.custom"
            class="clickable"
            @click="showDetailsPage($event, props.row['id'])"
          >
            <div>{{ props.row[column.field] }}</div>
          </div>
        </template>
      </b-table-column>

      <template #empty>
        <div class="empty-table">
          {{ $t("usersList.aucun-resultat") }}
        </div>
      </template>
    </b-table>
    <GRAEModale
      :open="openGRAEModale"
      :user="selectedUser"
      @close-modale="(refresh) => closeGRAEDialog(refresh)"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { eventBus } from "@/services/EventBus"
import type { ProfilUtilisateur } from "@/model/bean/GeneratedDTOs"
import { FilterDTO, GraeDTO, PaginationOrder, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { SortOrder } from "@/model/SortOrder"
import { Filters } from "@/model/bean/Filters"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { UsersService } from "@/services/rest/users/UsersService"
import { LoginService } from "@/services/rest/login/LoginService"
import { useTableView } from "@/hooks/useTableView"

import TableFilterView from "@/views/tables/TableFilterView.vue"
import Column from "@/views/tables/Column"
import { EnumHelper, PROFIL_UTILISATEUR } from "@/model/bean/EnumHelper"
import GraeMemberDemandeCard from "@/views/grae/GraeMemberDemandeCard.vue"
import { OrganismeService } from "@/services/rest/organisme/OrganismeService"
import GRAEModale from "@/pages/users_management/GRAEModale.vue"
import { BButton, BTable, BTableColumn, BSelect } from "buefy"

export default defineComponent({
  name: "GraeContactView",
  components: {
    TableFilterView,
    GraeMemberDemandeCard,
    GRAEModale,
    BButton,
    BSelect,
    BTable,
    BTableColumn,
  },
  props: {
    $loggedUser: {
      type: Object as PropType<UtilisateurDTO>,
      default: undefined,
    },
    grae: {
      type: Object as PropType<GraeDTO>,
      default: undefined,
    },
  },

  data() {
    return {
      userService: UsersService.INSTANCE,
      infoReportingService: InfoReportingService.INSTANCE,
      loginService: LoginService.INSTANCE,
      organismeService: OrganismeService.INSTANCE,

      // Hook sera initialisé dans created()
      tableView: null as any,

      // Méthodes spécifiques à cette classe
      userslist: [] as Array<UtilisateurDTO>,
      statusColumnField: "statutActivation",

      canDeleteUser: false,
      loggedUser: undefined as UtilisateurDTO | undefined,
      userBeingValidated: "" as string | undefined,
      userBeingRefused: "" as string | undefined,

      regionsList: [] as Array<string>,
      graesList: [] as Array<GraeDTO>,

      statut: {
        valide: this.$t("usersList.validate").toString(),
        refuse: this.$t("usersList.refuse").toString(),
        validated: this.$t("usersList.validated").toString(),
        refused: this.$t("usersList.refused").toString(),
      },

      demandesEnCours: [] as Array<UtilisateurDTO>,
      openGRAEModale: false,
      selectedUser: new UtilisateurDTO(),
      selectResetCounter: {} as Record<string, number>,
    }
  },
  computed: {
    PROFIL_UTILISATEUR() {
      return PROFIL_UTILISATEUR
    },
    // Propriétés réactives exposées par le hook
    tableRef(): string {
      return this.tableView?.state.tableRef || "contact-table"
    },
    isLoading(): boolean {
      return this.tableView?.state.isLoading || false
    },
    columns(): Array<Column> {
      return this.tableView?.state.columns || []
    },
    currentPagedSortedParameter(): any {
      return this.tableView?.state.currentPagedSortedParameter
    },
    buefySortingPriority(): Array<any> {
      return this.tableView?.state.buefySortingPriority || []
    },
    total(): number {
      return this.tableView?.state.total || 0
    },
    config(): any {
      return this.tableView?.state.config
    },
    activeFilters(): Array<FilterDTO> {
      return this.tableView?.state.activeFilters || []
    },
  },
  watch: {
    grae: {
      async handler(): Promise<void> {
        await this.reloadData()
      },
    },
  },
  created(): void {
    this.init()

    // Initialisation du hook avec binding correct
    this.tableView = useTableView({
      tableRef: "contact-table",
      router: this.$router,
      route: this.$route,
      i18n: this.$i18n,
      getInitialColumns: this.getInitialColumns.bind(this),
      getDefaultSort: this.getDefaultSort.bind(this),
      getInitialActiveFilters: this.getInitialActiveFilters.bind(this),
      reloadData: this.reloadData.bind(this),
      reloadDataWhenMounted: true,
    })
  },
  mounted(): void {
    // Get region lists for filtering purposes
    this.organismeService.getAllGraes().then((graes) => {
      this.graesList = graes
      this.regionsList = graes.map((g) => g.region)
      this.regionsList.push(this.$t("table-filter.none-region").toString())
      this.refreshInitialColumns()
      this.tableView?.initMounted()
    })
  },
  methods: {
    // Méthodes déléguées au hook
    updateActiveFilters(activeFilters: Array<FilterDTO>): void {
      this.tableView?.updateActiveFilters(activeFilters)
    },
    updateVisibleColumns(columns: Array<Column>): void {
      this.tableView?.updateVisibleColumns(columns)
    },
    onPageChange(newPage: string | number): void {
      const pageNum = typeof newPage === "string" ? parseInt(newPage) : newPage
      this.tableView.onPageChange(pageNum)
    },

    onSort(field: string | undefined, order: SortOrder): void {
      if (field) {
        this.tableView.onSort(field, order)
      }
    },

    sortingPriorityRemoved(field: string | undefined): void {
      if (field) {
        this.tableView.sortingPriorityRemoved(field)
      }
    },

    // Méthodes callbacks requises par le hook
    getInitialActiveFilters(): Array<FilterDTO> {
      return new Array<FilterDTO>()
    },
    updateTotal(total: number): void {
      this.tableView?.updateTotal(total)
    },
    refreshInitialColumns(): void {
      if (this.tableView) {
        this.tableView.state.columns = this.getInitialColumns()
      }
    },

    // Méthodes métier spécifiques au composant
    async init(): Promise<void> {
      this.loggedUser = this.$loggedUser

      if (!this.loggedUser) {
        this.loggedUser = this.loginService.getLoggedUser()
      }

      this.canDeleteUser = this.canDelete()
    },

    // It's a quick fix for now. cf #11603
    canDelete(): boolean {
      if (!this.loggedUser) {
        return false
      }

      return (
        this.loggedUserCanManageUsers() &&
        this.loggedUser.profil !== PROFIL_UTILISATEUR.ANIMATEUR_REGIONAL
      )
    },

    async reloadData(): Promise<void> {
      try {
        const activeFilters = this.getActiveFiltersForApis()

        const paginatedUserList = await this.userService.getAllUsers(
          this.currentPagedSortedParameter,
          activeFilters,
        )
        this.userslist = this.filter(paginatedUserList.elements)
        this.updateTotal(paginatedUserList.count)
      } catch (e: any) {
        // Silent catch
      }
      await this.loadDemandes()
    },

    getActiveFiltersForApis(): FilterDTO[] {
      //We want a copy of activeFilters
      const activeFilters = this.activeFilters.map((filter) => filter)
      if (
        this.loggedUser &&
        this.userService.isAccompagnateurRegional(this.loggedUser) &&
        this.loggedUser.grae
      ) {
        const graeRegion = this.grae ? this.grae.region : this.loggedUser.grae.region
        const newFilters = Filters.asFilters([
          {
            property: "profil",
            values: [PROFIL_UTILISATEUR.REFERENT, PROFIL_UTILISATEUR.ENSEIGNANT],
          },
          {
            property: "region",
            values: [graeRegion],
          },
        ])
        activeFilters.push(...newFilters)
      }
      return activeFilters
    },

    async loadDemandes(): Promise<void> {
      if (this.loggedUserCanManageUsers()) {
        try {
          this.demandesEnCours = await this.userService.getDemandesCreationCompteNationales()
        } catch (e: any) {
          // Silent catch
        }
      }
    },

    filter(users: Array<UtilisateurDTO>): Array<UtilisateurDTO> {
      return users
    },

    getInitialColumns(): Array<Column> {
      const possibleSearchProfils =
        this.loggedUser && this.userService.isAccompagnateurRegional(this.loggedUser)
          ? [PROFIL_UTILISATEUR.REFERENT, PROFIL_UTILISATEUR.ENSEIGNANT]
          : EnumHelper.allProfilsUtilisateur

      const columns: Column[] = [
        {
          field: "prenom",
          label: this.$t("usersList.prenom").toString(),
          sortable: true,
          backEndSearchable: true,
          visible: true,
          custom: false,
          canBeAdded: true,
        },
        {
          field: "nom",
          label: this.$t("usersList.nom").toString(),
          sortable: true,
          backEndSearchable: true,
          visible: true,
          custom: false,
          canBeAdded: true,
        },
        {
          field: "profil",
          label: this.$t("usersList.profil").toString(),
          tooltip: this.$t("usersList.profil-explanations").toString(),
          sortable: true,
          backEndSearchable: true,
          possibleSearchValues: possibleSearchProfils,
          visible: true,
          custom: true,
          canBeAdded: true,
        },
        {
          field: "courriel",
          label: this.$t("usersList.courriel").toString(),
          sortable: true,
          backEndSearchable: true,
          visible: true,
          custom: false,
          canBeAdded: true,
        },
        {
          field: "projets",
          label: this.$t("usersList.projets").toString(),
          sortable: true,
          backEndSearchable: true,
          visible: true,
          custom: false,
          canBeAdded: true,
        },
      ]

      if (this.loggedUser && this.userService.isObservateurNational(this.loggedUser)) {
        columns.push({
          field: "region",
          label: this.$t("usersList.region").toString(),
          sortable: true,
          backEndSearchable: true,
          possibleSearchValues: this.regionsList,
          visible: true,
          custom: true,
          canBeAdded: true,
        })
      }
      if (this.loggedUser && this.userService.isAccompagnateurNationalOrAdmin(this.loggedUser)) {
        columns.push(
          {
            field: "region",
            label: this.$t("usersList.region").toString(),
            sortable: true,
            backEndSearchable: true,
            possibleSearchValues: this.regionsList,
            visible: true,
            custom: true,
            canBeAdded: true,
          },
          {
            field: "statutActivation",
            label: this.$t("usersList.statut").toString(),
            tooltip: this.$t("usersList.statut-explanations").toString(),
            sortable: true,
            backEndSearchable: true,
            possibleSearchValues: EnumHelper.allStatusActivation,
            visible: true,
            custom: true,
            canBeAdded: true,
          },
          {
            field: "action",
            label: this.$t("projetPage.actions").toString(),
            sortable: false,
            backEndSearchable: false,
            visible: true,
            custom: true,
            canBeAdded: true,
          },
        )
      }

      return columns
    },

    getDefaultSort(): Array<PaginationOrder> {
      const defaultSort = new PaginationOrder()
      defaultSort.clause = "profil"
      defaultSort.desc = true
      return [defaultSort]
    },

    showDetailsPage(event: Event, id: number): void {
      // Do not foward click event to row (would trigger modal)
      event.stopPropagation()
      //For APP to open ProfileModale
      eventBus.emit("open-profile-modale", { show: true, id: id.toString() })
    },

    canPromote(user: UtilisateurDTO): boolean {
      return (
        this.loggedUserCanManageUsers() &&
        user.statutActivation == "ACTIF" &&
        user.profil == PROFIL_UTILISATEUR.ACCOMPAGNATEUR_REGIONAL
      )
    },

    promote(user: UtilisateurDTO): void {
      this.userService.promoteUser(user).then(
        (_success) => {
          this.reloadData()
        },
        (reject) => {
          this.infoReportingService.error(this.$t("userActions.cannot-promote").toString(), reject)
          this.updateSelectValue(user, "ACCOMPAGNATEUR_REGIONAL")
        },
      )
    },

    changeUserProfile(user: UtilisateurDTO, profil: ProfilUtilisateur): void {
      if (profil == "ACCOMPAGNATEUR_REGIONAL" && user.profil != profil) {
        if (this.loggedUser && this.loggedUser.id === user.id) {
          this.infoReportingService.dialog(
            this.$t("usersList.confirmation").toString(),
            this.$t("usersList.are-you-sure-demote").toString(),
            this.$t("usersList.demote").toString(),
            () => this.demote(user),

            "is-warning",
          )
          //If user has clicked on cancel button :
          this.updateSelectValue(user, "ANIMATEUR_REGIONAL")
        } else {
          this.demote(user)
        }
      }

      if (profil == "ANIMATEUR_REGIONAL" && user.profil != profil) {
        this.promote(user)
      }
    },

    updateSelectValue(user: UtilisateurDTO, value: string): void {
      const elements = this.$refs[`select-${user.id}`] as any[]

      if (!elements || elements.length === 0) {
        return
      }

      const select = elements[0]
      //@ts-ignore
      select.computedValue = value
    },

    canDemote(user: UtilisateurDTO): boolean {
      return (
        this.loggedUserCanManageUsers() &&
        user.statutActivation == "ACTIF" &&
        user.profil == PROFIL_UTILISATEUR.ANIMATEUR_REGIONAL
      )
    },

    demote(user: UtilisateurDTO): void {
      this.userService.demoteUser(user).then(
        (_success) => {
          this.reloadData()
        },
        (reject) => {
          this.infoReportingService.error(this.$t("userActions.cannot-demote").toString(), reject)
          this.updateSelectValue(user, "ANIMATEUR_REGIONAL")
        },
      )
    },

    canAccept(user: UtilisateurDTO): boolean {
      const hasExpectedProfilForRegional =
        [PROFIL_UTILISATEUR.ACCOMPAGNATEUR_REGIONAL, PROFIL_UTILISATEUR.ANIMATEUR_REGIONAL].indexOf(
          user.profil,
        ) >= 0

      const hasExpectedProfilForNational =
        [
          PROFIL_UTILISATEUR.OBSERVATEUR_NATIONAL,
          PROFIL_UTILISATEUR.ACCOMPAGNATEUR_NATIONAL,
        ].indexOf(user.profil) >= 0

      const hasExpectedProfilForSuperAdmin =
        [
          PROFIL_UTILISATEUR.SUPER_ADMINISTRATEUR,
          PROFIL_UTILISATEUR.ACCOMPAGNATEUR_NATIONAL,
        ].indexOf(user.profil) >= 0

      return (
        this.loggedUserCanManageUsers() &&
        user.statutActivation === "INSCRIPTION_A_VALIDER" &&
        (hasExpectedProfilForRegional ||
          (hasExpectedProfilForNational &&
            this.loggedUser?.profil === PROFIL_UTILISATEUR.ACCOMPAGNATEUR_NATIONAL) ||
          (hasExpectedProfilForSuperAdmin &&
            this.loggedUser?.profil === PROFIL_UTILISATEUR.SUPER_ADMINISTRATEUR))
      )
    },

    changeStatut(statutValue: string, user: UtilisateurDTO): void {
      if (statutValue === this.statut.valide) {
        this.accept(user)
      } else {
        this.deny(user)
      }
    },

    resetSelectStatus(user: UtilisateurDTO): void {
      const userId = String(user.id)
      if (!this.selectResetCounter[userId]) {
        this.selectResetCounter[userId] = 0
      }
      this.selectResetCounter[userId]++
    },

    accept(user: UtilisateurDTO): void {
      this.infoReportingService.dialogWithCancel(
        this.$t("usersList.confirmation").toString(),
        this.$t("usersList.are-you-sure-validate").toString(),
        this.$t("usersList.validate").toString(),
        () => this.validateUserRegistration(user),
        () => this.resetSelectStatus(user),
        "is-info",
      )
    },

    validateUserRegistration(user: UtilisateurDTO): void {
      this.userBeingValidated = user.id
      this.userService.validateUserRegistration(user).then(
        (_success) => {
          this.reloadData()
          this.userBeingValidated = ""
        },
        (reject) => {
          this.userBeingValidated = ""
          console.error("Could not validate user ", reject)
          this.infoReportingService.error(this.$t("userActions.cannot-validate").toString(), reject)
        },
      )
    },

    deny(user: UtilisateurDTO): void {
      this.infoReportingService.dialogWithCancel(
        this.$t("usersList.confirmation").toString(),
        this.$t("usersList.are-you-sure-deny").toString(),
        this.$t("usersList.refuse").toString(),
        () => {
          this.rejectUserRegistration(user)
        },
        () => this.resetSelectStatus(user),
        "is-danger",
      )
    },

    rejectUserRegistration(user: UtilisateurDTO): void {
      this.userBeingRefused = user.id
      this.userService.rejectUserRegistration(user).then(
        (_success) => {
          this.reloadData()
          this.userBeingRefused = ""
        },
        (reject) => {
          this.userBeingRefused = ""
          this.infoReportingService.error(this.$t("userActions.cannot-reject").toString(), reject)
        },
      )
    },

    deleteUser(event: Event, user: UtilisateurDTO): void {
      event.stopPropagation()
      let message = this.$t("usersList.are-you-sure-delete").toString()
      let type = "is-warning"
      if (user.hasAireEducative) {
        type = "is-danger"
        message = this.$t("usersList.delete-user-warning").toString()
      }
      this.infoReportingService.dialog(
        this.$t("usersList.confirmation").toString(),
        message,
        this.$t("usersList.delete").toString(),
        () => {
          this.deleteUserAccount(user)
        },
        type,
      )
    },

    isVisibleProjects(user: UtilisateurDTO): boolean {
      if (
        this.userService.hasAnyProfile(user, [
          PROFIL_UTILISATEUR.ENSEIGNANT,
          PROFIL_UTILISATEUR.REFERENT,
        ])
      ) {
        if (user.grae?.id) return true
      }
      return false
    },

    GoToProject(user: UtilisateurDTO): void {
      // Extract necessary values from the user object
      const graeId = user.grae?.id
      const name = user.nom
      // Get the current year and the previous year
      const currentYear = new Date().getFullYear()
      const previousYear = currentYear - 1
      const schoolYear = `${previousYear}-${currentYear}`
      // Construct the filters query parameter
      const filtersE = [
        {
          label: "Enseignants",
          property: "enseignant.name",
          values: [name],
        },
        {
          property: "anneeScolaire",
          values: [schoolYear],
        },
      ]
      const filtersR = [
        {
          label: "Référents",
          property: "referent.name",
          values: [name],
        },
        {
          property: "anneeScolaire",
          values: [schoolYear],
        },
      ]
      const filters = user.profil == PROFIL_UTILISATEUR.ENSEIGNANT ? filtersE : filtersR
      // Encode the filters object to a URI component
      const encodedFilters = encodeURIComponent(JSON.stringify(filters))
      // Construct the full URL
      const url = `/grae/details/0/${graeId}?filters=${encodedFilters}`
      // Use Vue Router to push the new route
      this.$router.push(url)
    },

    canValidateEmail(user: UtilisateurDTO): boolean {
      return (
        this.loggedUserCanManageUsers() &&
        user.statutActivation == "EMAIL_A_VALIDER" &&
        user.nom !== "N/A"
      )
    },

    validateEmail(event: Event, user: UtilisateurDTO): void {
      event.stopPropagation()
      const message = this.$t("usersList.are-you-sure-validate-email").toString()
      const type = "is-warning"
      this.infoReportingService.dialog(
        this.$t("usersList.confirmation").toString(),
        message,
        this.$t("usersList.validate-email").toString(),
        () => {
          this.userService.validateEmail(user).then(
            (_success) => {
              this.infoReportingService.success(
                this.$t("usersList.user-email-validated").toString(),
              )
              this.reloadData()
            },
            (reject) => {
              this.infoReportingService.error(
                this.$t("usersList.cannot-validate-email").toString(),
                reject,
              )
            },
          )
        },
        type,
      )
    },

    deleteUserAccount(user: UtilisateurDTO): void {
      this.userService.deleteUserAccount(user).then(
        (_success) => {
          this.infoReportingService.success(this.$t("usersList.user-deleted").toString())
          this.reloadData()
        },
        (reject) => {
          this.infoReportingService.error(this.$t("usersList.cannot-delete").toString(), reject)
        },
      )
    },

    loggedUserCanManageUsers(): boolean {
      return (
        this.loggedUser != undefined &&
        !this.userService.hasAnyProfile(this.loggedUser, [
          PROFIL_UTILISATEUR.OBSERVATEUR_NATIONAL,
          PROFIL_UTILISATEUR.ACCOMPAGNATEUR_REGIONAL,
          PROFIL_UTILISATEUR.REFERENT,
          PROFIL_UTILISATEUR.ENSEIGNANT,
        ])
      )
    },

    exportCSV(): void {
      const activeFilters = this.getActiveFiltersForApis()
      this.userService.exportUsersCSV(activeFilters)
    },

    exportXLS(): void {
      const activeFilters = this.getActiveFiltersForApis()
      this.userService.exportUsersXls(activeFilters)
    },

    openGRAEDialog(event: Event, user: UtilisateurDTO): void {
      event.stopPropagation()
      this.selectedUser = user
      this.openGRAEModale = true
    },

    closeGRAEDialog(refresh: boolean): void {
      this.openGRAEModale = false
      if (refresh) {
        this.reloadData()
      }
    },

    getInstructedGraeRegion(instructedGrae: string): string {
      const foundGrae = this.graesList.find((grae) => grae.id === instructedGrae)
      return foundGrae ? foundGrae.region : ""
    },
  },
})
</script>
